<template>
  <div class="page-container branches-page">
    <h1>Unsere Ausbildungszweige</h1>
    <div class="logo-container">
      <img src="@/assets/logo.png" alt="Logo HAK Liezen" class="logo">
    </div>
    <p class="welcome-message">Willkommen bei der HAK Liezen! Entdecke unsere vielseitigen Zweige und die praxisnahe Ausbildung.</p>

    <!-- Digital Business HAK -->
    <div class="info-section">
      <h2>Digital Business HAK</h2>
      <p>Praxisorientierte Ausbildung mit Schwerpunkten in Digitalisierung, Programmierung, Webdesign und unternehmerischem Denken. Perfekt für die Zukunft!</p>
      <img 
        src="@/assets/digbiz.png" 
        alt="Plakat Digital Business HAK" 
        class="branch-poster" 
        @click="openPreview('digbiz')" 
      />
      <button @click="navigateTo('https://www.hak-liezen.at/digbiz-hak.html')">Mehr erfahren</button>
    </div>

    <!-- Europa HAK -->
    <div class="info-section">
      <h2>Europa HAK</h2>
      <p>Internationale Ausbildung mit Fokus auf Fremdsprachen, interkulturelle Kompetenzen und Europaprojekte wie Erasmus+. Perfekt für eine Karriere im Ausland oder in internationalen Unternehmen.</p>
      <img 
        src="@/assets/europa.png" 
        alt="Plakat Europa HAK" 
        class="branch-poster" 
        @click="openPreview('europa')" 
      />
      <button @click="navigateTo('https://www.hak-liezen.at/europahak.html')">Mehr erfahren</button>
    </div>

    <!-- Tourismus HAK -->
    <div class="info-section">
      <h2>Tourismus HAK</h2>
      <p>Schwerpunkt auf Tourismusmanagement, Gastronomie und Veranstaltungsorganisation. Ideal für kreative Köpfe mit Interesse an der Hotellerie und Tourismusbranche.</p>
      <img 
        src="@/assets/tourismus.png" 
        alt="Plakat Tourismus HAK" 
        class="branch-poster" 
        @click="openPreview('tourismus')" 
      />
      <button @click="navigateTo('https://www.hak-liezen.at/klassik-hak.html')">Mehr erfahren</button>
    </div>

    <!-- Start Up -->
    <div class="info-section">
      <h2>Start Up</h2>
      <p>Vielseitige Ausbildung mit Schwerpunkt auf Wirtschaft, Digitalisierung und Unternehmertum – ideal für innovative Köpfe, die eine Karriere im Management oder als Gründer anstreben.</p>
      <img 
        src="@/assets/startup.png" 
        alt="Plakat Start Up" 
        class="branch-poster" 
        @click="openPreview('startup')" 
      />
      <button @click="navigateTo('https://www.hak-liezen.at/abendhak.html')">Mehr erfahren</button>
    </div>

    <!-- HAS -->
    <div class="info-section">
      <h2>Handelsschule (HAS)</h2>
      <p>Die HAS bietet eine praxisnahe Ausbildung mit Fokus auf kaufmännischen Fächern. Ideal für einen schnellen Berufseinstieg oder eine weiterführende Ausbildung.</p>
      <img 
        src="@/assets/has.png" 
        alt="Plakat Handelsschule" 
        class="branch-poster" 
        @click="openPreview('has')" 
      />
      <button @click="navigateTo('https://hak-liezen.at/praxis-has.html')">Mehr erfahren</button>
    </div>
    <!-- Abend HAK -->
    <div class="info-section">
      <h2>Abend HAK</h2>
      <p>Berufsbegleitende Ausbildung für Erwachsene, die ihren HAK-Abschluss nachholen oder sich beruflich weiterentwickeln möchten.</p>
      <img 
        src="@/assets/abendhak.png" 
        alt="Plakat Abend HAK" 
        class="branch-poster" 
        @click="openPreview('abendhak')" 
      />
      <button @click="navigateTo('https://hak-liezen.at/klassik-hak/abend-hak.html')">Mehr erfahren</button>
    </div>

    <!-- Modal für Vorschau -->
    <div v-if="previewImage" class="image-preview" @click="closePreview">
      <img :src="previewImage" alt="Vorschau des Plakats" />
    </div>
  </div>
</template>

<script>
export default {
  name: 'BranchesPage',
  data() {
    return {
      previewImage: null, // Speichert die aktuelle Vorschau-Bildquelle
    };
  },
  methods: {
    navigateTo(url) {
      window.open(url, '_blank'); // Öffnet den Link in einem neuen Tab
    },
    openPreview(imageName) {
      const imagePath = require(`@/assets/${imageName}.png`); // Dynamischer Import des Bildes
      this.previewImage = imagePath; // Bildquelle für die Vorschau setzen
    },
    closePreview() {
      this.previewImage = null; // Vorschau schließen
    }
  }
};
</script>

<style scoped>
/* CSS bleibt unverändert */
</style>


<style scoped>
.logo-container {
  display: inline-flex; /* Verwende inline-flex, um den Container nur so groß wie das Logo zu machen */
  justify-content: center; /* Zentriert das Logo horizontal */
  align-items: center; /* Zentriert das Logo vertikal */
  margin: 10px; /* Abstand um den Container herum */
  /*background-color: #98c1d9;  Optional: Hintergrundfarbe */
  border-radius: 10px; /* Abgerundete Ecken, optional */
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1); /* Optional: Schatten für Tiefe */
}

.logo {
  max-width: 100%; /* Responsives Logo */
  height: auto; /* Höhe proportional zur Breite */
  max-height: 100px; /* Maximale Höhe des Logos (anpassbar) */
}

.logo-container:hover {
  transform: scale(1.05); /* Leichte Vergrößerung beim Hover */
  transition: transform 0.3s; /* Sanfte Übergangsanimation */
}
.welcome-message {
  background-color: #98c1d9;
  color: white;
  padding: 10px;
  border-radius: 5px;
  margin-bottom: 20px;
}

.info-section {
  margin-bottom: 30px;
  text-align: center;
}

.page-container {
  text-align: center;
  padding: 20px;
}

.school-image {
  max-width: 100%;
  height: auto;
  margin: 20px 0;
  border-radius: 8px;
}

.branch-poster {
  max-width: 50%;
  margin: 15px auto;
  border-radius: 10px;
  box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);
  cursor: pointer;
  transition: transform 0.3s ease;
}

.branch-poster:hover {
  transform: scale(1.05);
}

button {
  background-color: #ff6600;
  color: white;
  padding: 10px 20px;
  border: none;
  border-radius: 5px;
  cursor: pointer;
  margin-top: 10px;
  font-size: 16px;
  transition: background-color 0.3s ease;
}

button:hover {
  background-color: #e55a00;
}

/* Vorschau-Modul */
.image-preview {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.8);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 1000;
}

.image-preview img {
  max-width: 90%;
  max-height: 90%;
  border-radius: 10px;
  box-shadow: 0 4px 6px rgba(0, 0, 0, 0.3);
  cursor: pointer;
}

.image-preview:hover {
  cursor: zoom-out;
}

/* Mobile-Optimierung */
@media (max-width: 600px) {
  .branch-poster {
    max-width: 70%;
  }
}
</style>
